<script setup>
/**
 * Horizontal toolbar strip used inside HrHeader or other surface areas.
 *
 * @status recommended
 * @group navigation
 * @useWhen Laying out icon buttons, title, and action items in a horizontal bar
 * @within hr-header
 * @see https://quasar.dev/vue-components/toolbar Quasar q-toolbar API
 */
defineOptions({ name: 'HrToolbar' });
</script>

<template>
  <q-toolbar v-bind="$attrs">
    <!-- @slot Toolbar content — icon buttons, title, and action items. -->
    <slot />
  </q-toolbar>
</template>
